import { putAlertStatusClose } from "api/alertAPI";
import { AlertStatusResponse } from "api/interfaces/alertInterface.interface";
import { CustomError } from "api/interfaces/commonInterface.interface";
import useApiError from "hook/useApiError";
import { useQueryClient } from "react-query";
import useStatusMutation from "./useStatusMutation";

const DEFAULT_INVALIDATE_KEYS = [
  "activeAlert",
  "alertHistoryList",
  "alertViewList",
  "searchMapFilterResult",
];

interface Options {
  invalidateQueryKeys?: string[];
  onSuccess?: (res: AlertStatusResponse) => void;
  onError?: (err: CustomError) => void;
}

export default function useAlertStatusCloseMutation(options: Options = {}) {
  const { handleErrorNotify, lang, notifySuccess } = useApiError();
  const queryClient = useQueryClient();

  const invalidateQueryKeys = [
    ...DEFAULT_INVALIDATE_KEYS,
    ...(options.invalidateQueryKeys ?? []),
  ];

  return useStatusMutation(putAlertStatusClose, {
    onSuccess: (res: AlertStatusResponse) => {
      invalidateQueryKeys.forEach((key) => queryClient.invalidateQueries(key));
      notifySuccess(lang.label.alert.notify.status.success);
      options.onSuccess?.(res);
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.label.alert.notify.status.fail);
      options.onError?.(err);
    },
  });
}
